/**
 * Empty in dev so requests are same-origin and hit the Vite proxy; set to the deployed
 * API's absolute URL at build time in production, where the SPA and the API are separate
 * Dokploy services on different hostnames.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/** Distinct from the web app's key so signing out of one does not disturb the other. */
export const SESSION_STORAGE_KEY = 'proctoring.backoffice.session';
